/**
 * Centralized localStorage keys enum
 * This is in a separate file to avoid circular dependencies
 */
export enum LocalStorageKeys {
  UI_MODE_PREFERENCE = 'uiModePreference',
  AUDIT_TRAIL_COLUMNS = 'auditTrailColumns',
  IAM_MATRIX_COMPONENT_ACTIONS = 'iamMatrixComponentActions',
  IAM_MATRIX_SUBJECT_FILTER = 'iamMatrixSubjectFilter',
  IAM_MATRIX_WORKSPACE_FILTER = 'iamMatrixWorkspaceFilter',
  EULA_ACCEPTED = 'eulaAccepted',
  OIDC_KEY = 'oidcKey',
  DISMISSED_FEATURESTORE_LICENCE_NOTICES = 'dismissedFeaturestoreLicenceNotices',
  WORKFLOWS_ALL_RUNS_LIST_FROM_ALL_WORKSPACES = 'workflowsAllRunsListFromAllWorkspaces',
  RECENT_APPS = 'recentApps',
  DARK_MODE = 'darkMode',
  HOMEPAGE_LAYOUT = 'homepageLayout',
}

/**
 * Centralized sessionStorage keys enum.
 *
 * sessionStorage is per-browser-tab, so values keyed here are NOT shared across
 * tabs (unlike `LocalStorageKeys`). Use it for state that must be independent
 * per tab while still surviving a reload or a brief external round-trip.
 */
export enum SessionStorageKeys {
  // The tab's active workspace. Kept per-tab so a user can work in different
  // workspaces in different tabs; survives reload and external round-trips.
  ACTIVE_WORKSPACE = 'activeWorkspace',
}
